import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  select(event) {
    const channel = event.currentTarget.dataset.channel;
    this.show(channel);
  }

  show(channel) {
    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.channel === channel;
      tab.setAttribute("aria-selected", selected.toString());
      tab.setAttribute("tabindex", selected ? "0" : "-1");
      tab.classList.toggle("ui-tab-item-active", selected);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.channel !== channel);
    });
  }
}
